<template>
  <v-content>
    <v-container>
      <v-row justify="center">
        <v-col cols="12">
          <div class="text-center">
            <v-btn
              class="mx-2"
              href="https://www.instagram.com/prohemoceoficial/"
              target="_blank"
              fab
              dark
              small
              color="pink"
            >
              <v-icon dark>mdi-instagram</v-icon>
            </v-btn>
            <v-btn
              class="mx-2"
              href="https://www.facebook.com/prohemoceoficial"
              target="_blank"
              fab
              dark
              small
              color="primary"
            >
              <v-icon dark>mdi-facebook</v-icon>
            </v-btn>
            <v-btn
              class="mx-2"
              href="https://www.youtube.com/channel/UCH-wDrBjMLWYnLfjfbDbVQQ"
              target="_blank"
              fab
              dark
              small
              color="red"
            >
              <v-icon dark>mdi-youtube</v-icon>
            </v-btn>
            <v-btn
              class="mx-2"
              href="https://prohemo.org.br"
              target="_blank"
              fab
              dark
              small
              color="secondary"
            >
              <v-icon dark>mdi-web</v-icon>
            </v-btn>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </v-content>
</template>

<script>
export default {
  name: 'SocialMedia',
}
</script>

